import React, { useEffect } from "react";
import QlikCard from "shared/components/QlikCard";
import QlikObject from "shared/components/QlikObject";

export default function Participants({ title, pageTitle, menuItemsStrings }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);
  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <QlikObject
              className="page-title"
              id="GUTUWU"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject id="qHRNLp" height="35px" showLoader={false} />
          </div>
        </div>
      </div>

      <div className="container-fluid">
        
        <div className="row justify-content-right mb-2">
          <div className="col-md-2 col-sm-4 col-12">
            <QlikObject id="TqYJnj" height="40px" showLoader={false} />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            {/* vizTable */}
            <QlikCard
              id="7eea4556-fdab-4c66-8e6e-415181068828"
              height="670px"
              showLoader={true}
              showExport={true}
              showHeader={true}
              exportText = {menuItemsStrings.exportText}
              exportCompletedText = {menuItemsStrings.exportCompletedText}
              closeBtnText = {menuItemsStrings.closeBtnText}
            />
          </div>
        </div>


        

      </div>
    </section>
  );
}
